import Button from 'Components/Base/Button'
import Icon from 'Components/Base/Icon'
import StateDropdown from 'Components/Base/StateDropdown'
import { FormikProps, getIn } from 'formik'
import { PrimaryPhysicianState } from 'hooks/usePatientIntake'
import React from 'react'
import { Form } from 'react-bootstrap'
import { useTheme } from 'styled-components'
import '../PhysiciansForm.scss'

interface Props {
  cancelInput: () => void
  props: FormikProps<PrimaryPhysicianState>
  handleSetPrimaryPhysician: (phys: PrimaryPhysicianState) => void
}
export default function PhysicianCard({ cancelInput, props, handleSetPrimaryPhysician }: Props) {
  const theme = useTheme()
  function getStyles(fieldName: string) {
    if (getIn(props.errors, fieldName)) {
      return {
        border: '2px solid red',
        boxShadow: 'none',
      }
    }
  }

  const onSubmit = () => {
    props.setFieldValue('hasPrimaryPhysician', true)
    props.setFieldValue('patientAdded', true)
    handleSetPrimaryPhysician(props.values)
  }

  return (
    <div className="physician-card">
      <div onClick={cancelInput} className="intake-cancel-box">
        <Icon name="times" color="#bdbdbd" size="2xl" styles={{ height: '100%', width: '90%' }} />
      </div>
      <div className="physician-card-group" style={{ marginTop: 15 }}>
        <Form.Control
          type="text"
          onChange={(e) => props.setFieldValue('firstName', e.currentTarget.value)}
          style={{
            ...getStyles('firstName'),
          }}
          value={props.values.firstName}
          placeholder="Physician First Name *"
          className="login-input physician-input"
        />
        <div className="input-spacer" />
        <Form.Control
          type="text"
          required
          style={{
            ...getStyles('lastName'),
          }}
          onChange={(e) => props.setFieldValue('lastName', e.currentTarget.value)}
          value={props.values.lastName}
          placeholder="Physician Last Name *"
          className="login-input physician-input"
        />
      </div>
      <div className="physician-card-group">
        <Form.Control
          type="text"
          onChange={(e) => props.setFieldValue('city', e.currentTarget.value)}
          style={{
            ...getStyles('city'),
          }}
          value={props.values.city}
          placeholder="City *"
          className="login-input physician-input"
        />
        <div className="input-spacer" />
        <StateDropdown onFieldUpdated={(e) => props.setFieldValue('state', e.currentTarget.value)} value={props.values.state} label="State *" />
      </div>
      <Button
        text="Add"
        leftIcon="circle-plus"
        backgroundColor={theme.colors.status.good}
        styles={{ marginBottom: 0, marginLeft: 30 }}
        onClick={() => onSubmit()}
      />
    </div>
  )
}
